<template>
    <div class="px-8 py-6">
        <div class="text-2xl font-semibold pb-6 flex items-center border-b border-gray-300 text-gray-700 tracking-wide">{{ subGroupName }}</div>
        <div>
            <TrainingDocumentContainer 
                v-for="trainingDocument in trainingDocuments" 
                :key="trainingDocument.id" 
                :training-document="trainingDocument"
            />
        </div>
    </div>
</template>

<script setup>
import { defineProps, computed } from 'vue';
import TrainingDocumentContainer from './TrainingDocumentContainer.vue';

const props = defineProps(['subGroup'])

const subGroupName = computed(() => {
    return props.subGroup ? props.subGroup.name : '--'
})

const trainingDocuments = computed(() => {
    return props.subGroup && props.subGroup.training_documents ? props.subGroup.training_documents : []
})

</script>